import { render, staticRenderFns } from "./information.form.vue?vue&type=template&id=3c23e6af&"
import script from "./information.form.vue?vue&type=script&lang=ts&"
export * from "./information.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports